<template>
    <div>
        <div class="overflow-auto table-fixed-adjust">
            <table>
                <thead>
                    <tr>
                        <th class="p-1 btn btn-default btn-sm px-2 table-fixed" @click="handlePrevious()">{{
                            trans.congestion.title.previous }}</th>
                        <td class="p-1 text-center" v-for="(time, index) in baseTime" :key="index">
                            {{ time.title }}
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(date, index) in dates" :key="index">
                        <td class="p-1 white-space-nowrap table-fixed">{{ date.title }}</td>
                        <td class="p-1"
                            @click="handleSetDateTimeItem(time, date.date, $event, checkDisabled(time, date.date, index))"
                            v-for="(time, i) in baseTime" :key="i">
                            <congestion-icon-level data-toggle="modal" data-target="#editMainItemLevel"
                                :is-disabled="checkDisabled(time, date.date, index)" :level="iconLevel(time, date.date, 1)"
                                :type="0" :key="i" :re-render="reRenderLevelItem"
                                :is-current="isCurrentLevel(time, date.date)" :is-based="isBased(time, date.date)">
                            </congestion-icon-level>
                        </td>
                    </tr>
                    <tr>
                        <th @click="handleNext()" class="btn btn-default btn-sm px-2 table-fixed mb-4 mt-2">{{
                            trans.congestion.title.next }}</th>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- Modal edit congestion item -->
        <div class="modal fade" id="editMainItemLevel" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ trans.btn.edit }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="container">
                            <div class="row row-cols-5">
                                <div class="col-sm" v-for="(level, index) in levelSettingData" :key="index"
                                    @click="handleSetLevelItem(level, $event)">
                                    <congestion-icon-level :level="level.level" :type="0" data-toggle="modal"
                                        data-target="#editMainItemLevel" :key="index"></congestion-icon-level>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CongestionIconLevel from "./CongestionIconLevel";

export default {
    props: {
        trans: {
            type: Object,
            required: true
        },
        congestionData: {
            type: Object,
            default: function () {
                return null;
            }
        },
        levelSettingData: {
            type: Array,
            default: function () {
                return [];
            }
        },
        dateTimeSettingData: {
            type: Array,
            default: function () {
                return [];
            }
        },
        scheduleData: {
            type: Array,
            default: function () {
                return [];
            }
        },
        currentDateTime: {
            type: String,
            required: true
        },
    },
    components: { CongestionIconLevel },
    data() {
        return {
            scheduleItem: {
                level_setting_id: null,
                datetime: '',
                type: 1
            },
            disabledDate: null,
            startDate: moment(),
            dates: [],
            reRenderLevelItem: 0,
            isChooseCurrentLevel: false,
        }
    },
    methods: {
        submit() {
            let formData = new FormData();
            formData.append('datetime', this.scheduleItem.datetime);
            formData.append('level_setting_id', this.scheduleItem.level_setting_id);
            if (this.scheduleData.length > 0) {
                formData.append("_method", "PUT");
            }
            
            let self = this;
            axios({
                method: "POST",
                url: `/congestions/${this.congestionData.id}/schedule`,
                data: formData,
                headers: {
                    'content-type': 'multipart/form-data'
                }
            }).then((response) => {
                if (self.isChooseCurrentLevel) {
                    window.location.reload();
                }
            })
        },
        handleSetDateTimeItem(time, date, event, disabled) {
            if (disabled) return;
            const formattedTime = moment().startOf('day').add(time.value, 'hours').format('HH');
            this.scheduleItem.datetime = `${date} ${formattedTime}`;
            this.isChooseCurrentLevel = this.isCurrentLevel(time, date);
        },
        handleSetLevelItem(level, event) {
            this.scheduleItem.level_setting_id = level.id;

            const index = this.scheduleData.findIndex(item => item.datetime === `${this.scheduleItem.datetime}:00:00`);
            const updatedItem = {
                "type": this.scheduleItem.type,
                "datetime": `${this.scheduleItem.datetime}:00:00`,
                "congestion_level_setting": level
            };

            if (index !== -1) {
                this.scheduleData[index] = updatedItem;
            } else {
                this.scheduleData.push(updatedItem);
            }
            this.reRenderLevelItem += 1;
            $('#editMainItemLevel').modal('hide');
            this.submit();
        },
        iconLevel(time, date, type) {
            const formattedTime = moment().startOf('day').add(time.value, 'hours').format('HH:00:00');
            const datetime = `${date} ${formattedTime}`;
            let level = this.scheduleData.find(e => e.datetime === datetime && e.type === type);
            if (!level) {
                level = this.baseSchedule.find(e => moment(e.datetime).format('ddd HH') === moment(datetime).format('ddd HH'));
            }
            return level?.congestion_level_setting?.level ?? 0;
        },
        checkDisabled(time, date, index) {
            const formattedTime = moment().startOf('day').add(time.value, 'hours').format('HH');
            const datetime = `${date} ${formattedTime}`;
            return this.currentDateTime > datetime || !this.baseDate.some(md => md.value === index);
        },
        updateDates() {
            const startOfWeek = this.startDate.clone().startOf("isoWeek");
            const endOfWeek = this.startDate.clone().endOf("isoWeek");

            const dates = [];
            let currentDate = startOfWeek.clone();

            while (currentDate.isSameOrBefore(endOfWeek)) {
                const formattedTitle = currentDate.format('MM/DD (ddd)');
                const formattedDate = currentDate.format('YYYY-MM-DD');
                dates.push({
                    title: formattedTitle,
                    date: formattedDate
                });
                currentDate.add(1, "days");
            }

            this.dates = dates;
        },
        handleNext() {
            this.startDate.add(1, "weeks");
            this.updateDates();
        },
        handlePrevious() {
            this.startDate.subtract(1, "weeks");
            this.updateDates();
        },
        isCurrentLevel(time, date) {
            const formattedTime = moment().startOf('day').add(time.value, 'hours').format('HH');
            const datetime = `${date} ${formattedTime}`;
            return datetime === this.currentDateTime;
        },
        isBased(time, date) {
            const formattedTime = moment().startOf('day').add(time.value, 'hours').format('HH:00:00');
            const datetime = `${date} ${formattedTime}`;
            let level = this.scheduleData.find(e => e.datetime === datetime);
            if (!level) {
                level = this.baseSchedule.find(e => moment(e.datetime).format('ddd HH') === moment(datetime).format('ddd HH'));
            }
            return level && level.type === 0;
        },
    },
    computed: {
        baseTime() {
            const baseTime = [];
            for (let i = 0; i < this.dateTimeSettingData.length; i++) {
                const element = this.dateTimeSettingData[i];
                if (element['type'] === 1) {
                    element['title'] = moment().startOf('day').add(element.value, 'hours').format('hA');
                    baseTime.push(element);
                }
            }
            return baseTime;
        },
        baseDate() {
            const baseDate = [];
            for (let i = 0; i < this.dateTimeSettingData.length; i++) {
                const element = this.dateTimeSettingData[i];
                if (element['type'] === 0) {
                    element['title'] = moment().startOf('week').add(element.value, 'day');
                    baseDate.push(element);
                }
            }
            return baseDate;
        },
        baseSchedule() {
            return this.scheduleData.filter(item => item.type === 0);
        }
    },
    mounted() {
        this.updateDates();
    },
}
</script>
<style>
.table-fixed {
    position: absolute;
    width: 62px;
    left: 18px;
    background-color: #fff;
    z-index: 10;
}

.table-fixed-adjust {
    margin-left: 60px;
    margin-bottom: 40px;
}
</style>